import { useEffect, useState } from "react";
import { Lock, ArrowRight } from "@phosphor-icons/react";
import api from "../lib/api";
import { getCachedSiteContent } from "../lib/useSiteContent";

export default function UpsellModal({ open, onClose, feature = "Private Insights" }) {
  const _sc0 = getCachedSiteContent();
  const [title, setTitle] = useState(_sc0.subscriber_upsell_dialog_title || "Upgrade to Enterprise");
  const [body, setBody] = useState(_sc0.subscriber_upsell_dialog_body || "");
  const [salesEmail, setSalesEmail] = useState(_sc0.sales_email || "sales@oodel.co");

  useEffect(() => {
    if (!open) return;
    api.get("/site-content").then((r) => {
      const sc = r.data || {};
      setTitle(sc.subscriber_upsell_dialog_title || "Upgrade to Enterprise");
      setBody(sc.subscriber_upsell_dialog_body || "");
      setSalesEmail(sc.sales_email || "sales@oodel.co");
    }).catch(() => {});
  }, [open]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 themable-modal"
      onClick={onClose}
      data-testid="upsell-modal"
      style={{ color: "#0A0A0A" }}
    >
      <div
        className="max-w-lg w-full p-8 border-2"
        onClick={(e) => e.stopPropagation()}
        style={{ background: "#ffffff", borderColor: "#0A0A0A", color: "#0A0A0A", boxShadow: "8px 8px 0 rgba(0,0,0,0.15)" }}
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 flex items-center justify-center" style={{ background: "#16A34A" }}>
            <Lock size={24} weight="fill" style={{ color: "#ffffff" }} />
          </div>
          <div>
            <div className="overline" style={{ color: "#525252" }}>PREMIUM</div>
            <h3 className="text-xl font-bold tracking-tight" style={{ color: "#0A0A0A" }} data-testid="upsell-title">{title}</h3>
          </div>
        </div>
        <p className="mb-6 leading-relaxed" style={{ color: "#404040" }} data-testid="upsell-body">
          {body || `Subscribers and Enterprise clients unlock the full oodel. intelligence stack — sector dashboards, crosstab explorers, audio briefings and a Private Insights vault for commissioned research. ${feature} is part of the Enterprise tier.`}
        </p>
        <div className="space-y-2 mb-6">
          <Tier name="Annual Subscriber" perks={["All public trackers", "Crosstab explorer", "Editorial + audio access"]} />
          <Tier name="Enterprise Client" perks={["Everything above", "Private Insights vault", "Custom waves & questions", "Dedicated PM"]} />
        </div>
        <div className="flex gap-2">
          <a
            href={`mailto:${salesEmail}?subject=${encodeURIComponent("oodel Premium Inquiry")}`}
            className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-3 font-semibold border-2"
            style={{ background: "#16A34A", color: "#ffffff", borderColor: "#0A0A0A", boxShadow: "4px 4px 0 rgba(0,0,0,0.15)" }}
            data-testid="upsell-contact"
          >
            Contact Sales <ArrowRight size={16} />
          </a>
          <button
            onClick={onClose}
            className="px-5 py-3 border"
            style={{ borderColor: "#d4d4d4", background: "#ffffff", color: "#0A0A0A" }}
            data-testid="upsell-close"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}

function Tier({ name, perks }) {
  return (
    <div className="p-4 border" style={{ borderColor: "#e5e5e5", background: "#ffffff" }}>
      <div className="font-bold" style={{ color: "#0A0A0A" }}>{name}</div>
      <ul className="mt-2 text-xs space-y-0.5" style={{ color: "#525252" }}>
        {perks.map((p) => <li key={p}>· {p}</li>)}
      </ul>
    </div>
  );
}
